import React from 'react';

// Phase 2 (2026-10-12): replaces the former full-screen lockout. An expired
// firm keeps its records and essential practice management; only paid AI /
// automation services pause (enforced server-side). Admins get the renewal
// path; members are told who can renew.
const ExpiredSubscriptionBanner = ({ subStatus, userRole, onRenew }) => {
  if (!subStatus || subStatus.isSuperAdmin) return null;
  const inGrace = !!subStatus.isInGrace;
  if (!subStatus.isExpired && !inGrace) return null;
  const isAdmin = userRole === 'admin';
  const graceDate = inGrace && subStatus.graceEndsAt
    ? new Date(subStatus.graceEndsAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Africa/Accra' })
    : null;
  const tone = inGrace
    ? { bg: 'rgba(245,158,11,0.10)', border: 'rgba(245,158,11,0.35)', fg: '#f59e0b' }
    : { bg: 'rgba(239,68,68,0.10)', border: 'rgba(239,68,68,0.35)', fg: '#ef4444' };
  const title = inGrace ? 'Your subscription payment is overdue' : "Your firm's subscription has expired";
  const body = inGrace
    ? `Paid features stay on until ${graceDate}. Renew before then to avoid an interruption.`
    : 'Your matters, clients, documents, calendar, invoices and client portal are all still available. AI assistance, AI research, document intelligence and automations are paused until the subscription is renewed.';
  return (
    <div role="status" data-testid="expired-subscription-banner" style={{
      background: tone.bg, border: `1px solid ${tone.border}`, borderRadius: '12px',
      padding: '0.85rem 1rem', margin: '0 0 1rem', display: 'flex', alignItems: 'center',
      justifyContent: 'space-between', gap: '0.75rem', flexWrap: 'wrap', fontFamily: "'DM Sans', sans-serif",
    }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ color: tone.fg, fontWeight: 700, fontSize: '0.92rem' }}>{title}</div>
        <div style={{ color: '#a8adb7', fontSize: '0.84rem', marginTop: '0.2rem', lineHeight: 1.5 }}>
          {body}{!isAdmin && ' Please ask your firm administrator to renew.'}
        </div>
      </div>
      {isAdmin && (
        <button onClick={onRenew} style={{
          padding: '0.55rem 1.1rem', borderRadius: '9px', border: 'none', cursor: 'pointer',
          background: 'linear-gradient(135deg, #d4a853, #e8c875)', color: '#080a10',
          fontWeight: 700, fontSize: '0.85rem', fontFamily: 'inherit', flexShrink: 0,
        }}>Renew subscription</button>
      )}
    </div>
  );
};

export default ExpiredSubscriptionBanner;
